import { useState, useEffect, useRef  } from 'preact/hooks';
import { replaceAll, replaceData } from '../../../utilities/common';
import { validatorMap } from '../../../constants/Validators';
import { updateAnchorTextAction } from '../../../actions/UserData';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const AnchorInputText = (props) => {

  const {
    id,
    value,
    values,
    variant,
    placeholder,
    label,
    translations,
    readonly,
    children,
    setValues,
    validators,
    dispatch,
    maxLength,
    columns
  } = props;

  const formFieldClass = classNames(
    {
      [`form__field--${columns}col`]: columns
    }
  );

  const [replaceValue, setReplacedValue] = useState("");
  const [error, setError] = useState("");
  const [isReadOnly, setReadOnly] = useState(readonly);
  const inputRef = useRef(null);

  // using existing validation rules in calcnbuy
  const validateInput = () => {
    let errors = {};
    const child = children.find( child => child.id === id);
    // Loop validators and run each one.
    validators.every(validator => {
      // Ignore if validator does not exist.
      if (!Object.hasOwnProperty.call(validatorMap, validator.name)) {
        return;
      }

      //show the most recent error from stack
      if (!validatorMap[validator.name](values, id, validator, child)) {
        errors[id] = validator.errorMsg;
        return false;
      } else {
        return true;
      }
    });

    return errors;
  }

  //capture input event to update formvalue and userdata
  const inputEventFn = (event) => {
    let data = {};
    values[id] = event.detail.value;
    data[id] = event.detail.value;
    setValues({
      ...values
    });
    dispatch(updateAnchorTextAction({
      ...data
    }));
  }

  //capture error event after user moves away from the input
  const blurEventFn = () => {
    const errors = validateInput();
    setError(errors[id]);
  }
  
  useEffect(() => {
      let newValue = replaceData(value, values, false, false, false, true);

      // populate variant styles
      if(variant === "tel") {
        newValue = newValue.replace(/(.{2})/g, "$1 ").trim();
      }

      //override read only
      if(newValue === "") {
        setReadOnly(false);
      }
    
      setReplacedValue(prevValue => newValue);

      inputRef.current.addEventListener('inputevent', inputEventFn);
      inputRef.current.addEventListener('blurevent', blurEventFn);

      return () => {
        inputRef.current.removeEventListener('inputevent', inputEventFn);
        inputRef.current.removeEventListener('blurevent', blurEventFn);
      }

  }, []);

  return (
      <div id={id} className={formFieldClass}>    
          <anchor-input 
            name="text input" 
            readonly={isReadOnly} 
            value={replaceValue}
            placeholder={replaceAll(placeholder, translations, values)}
            ref={inputRef}
            error-prop={replaceAll(error, translations, values)}
            maxLength={maxLength}
            style={isReadOnly ? "--input-field-padding-top: 0px; --p-size-static-100: 0px; --s-color-text-default: bold;": ""}
          >
              {replaceAll(label, translations, values)}
          </anchor-input>
      </div>
  )
}

export default compose(
  connect(state => {
    const {
      section: {
        packageData: { translations },
      }
    } = state;

    return { translations };
  })
)(AnchorInputText);
  
AnchorInputText.defaultProps = {
  placeholder: "",
  translations: {},
  readonly: false
};
  
AnchorInputText.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  values: PropTypes.object.isRequired,
  translations: PropTypes.object,
  readonly:PropTypes.bool,
  id: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  maxLength: PropTypes.number,
  columns: PropTypes.number
};